import {ChangeDetectorRef, Directive, HostBinding, Input, OnChanges, OnInit} from "@angular/core";

@Directive({
  selector: 'int-badge'
})
export class BaseBadgeDirective implements OnChanges, OnInit {

  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  @Input() mode: 'success' | 'default' | 'danger' | string = 'default';

  @HostBinding('attr.data-size') get _size() {
    return this.size;
  }

  @HostBinding('attr.data-mode') get _mode() {
    return this.mode;
  }

  constructor(
    protected readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.cdr.markForCheck();
  }

  ngOnChanges() {
    this.cdr.markForCheck();
  }
}
